var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PurchaseOrderAddDialog',{attrs:{"value":_vm.value,"mode":"edit","record":_vm.record,"buying-station-id":_vm.buyingStationId},on:{"input":function($event){return _vm.$emit('input', $event)},"save":function($event){return _vm.$emit('save', $event)},"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }